import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock, Package } from "lucide-react";
import { format } from "date-fns";

interface Shipment {
  id: string;
  pickup_date: string;
  pickup_time_slot: string;
  status: string;
  box_count: number;
}

interface PickupDetailsCardProps {
  shipment: Shipment;
}

export function PickupDetailsCard({ shipment }: PickupDetailsCardProps) {
  const getStatusBadge = (status: string) => {
    const statusConfig = {
      scheduled: { variant: "secondary" as const, label: "Scheduled" },
      in_transit: { variant: "default" as const, label: "In Transit" },
      completed: { variant: "outline" as const, label: "Completed" },
      cancelled: { variant: "destructive" as const, label: "Cancelled" },
    };
    
    const config = statusConfig[status as keyof typeof statusConfig] || statusConfig.scheduled;
    return <Badge variant={config.variant}>{config.label}</Badge>;
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center justify-between">
          <span>Pickup to Storage Facility</span>
          {getStatusBadge(shipment.status)}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-start gap-3">
          <Calendar className="h-4 w-4 mt-0.5 text-muted-foreground" />
          <div>
            <p className="text-sm font-medium">Pickup Date</p>
            <p className="text-sm text-muted-foreground">
              {format(new Date(shipment.pickup_date), "EEEE, MMMM d, yyyy")}
            </p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <Clock className="h-4 w-4 mt-0.5 text-muted-foreground" />
          <div>
            <p className="text-sm font-medium">Time Slot</p>
            <p className="text-sm text-muted-foreground">{shipment.pickup_time_slot}</p>
          </div>
        </div>
        
        <div className="flex items-start gap-3">
          <Package className="h-4 w-4 mt-0.5 text-muted-foreground" />
          <div>
            <p className="text-sm font-medium">Boxes in Pickup</p>
            <p className="text-sm text-muted-foreground">{shipment.box_count} box(es)</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
